import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SpotChat = props => {
  const maskId = `spot-chat-mask-${props['data-id']}`;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props, {
    viewBox: "0 0 72 72"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.132 .157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: maskId,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.253895716 0.00793894609L71.6741876 0.00793894609 71.6741876 71.8640016 0.253895716 71.8640016z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M35.964.008c19.722 0 35.71 16.085 35.71 35.928 0 19.843-15.988 35.928-35.71 35.928S.254 55.78.254 35.936C.254 16.093 16.242.008 35.964.008",
    mask: `url(#${maskId})`
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(10.968 18.709)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE4923",
    d: "M47.27 25.688c.86 0 1.558-.697 1.558-1.556V1.557C48.828.697 48.13 0 47.27 0H14.576c-.86 0-1.557.697-1.557 1.557v24.131h34.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.8817789 4.67063568L44.9008712 4.67063568 44.9008712 6.22751424 16.8817789 6.22751424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.4863325 9.34127137L44.9008712 9.34127137 44.9008712 10.8981499 39.4863325 10.8981499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.4863325 13.8442481L44.9008712 13.8442481 44.9008712 15.4011267 39.4863325 15.4011267z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD059",
    d: "M21.796 36.08H35.03c.86 0 1.557-.696 1.557-1.556V11.17c0-.86-.697-1.557-1.557-1.557H1.557C.697 9.614 0 10.31 0 11.17v23.353c0 .86.697 1.557 1.557 1.557h20.24z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EE4923",
    transform: "translate(2.892 15.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.892196402 4.67063568L14.8068752 4.67063568 14.8068752 6.22751424 0.892196402 6.22751424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.892196402 0.334698183L30.210959 0.334698183 30.210959 1.89157674 0.892196402 1.89157674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7903463 4.67063568L30.210959 4.67063568 30.210959 6.22751424 11.7903463 6.22751424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.34127137L9.56283209 9.34127137 9.56283209 10.8981499 1 10.8981499z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6772089L14.8068752 13.6772089 14.8068752 15.2340874 1 15.2340874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56283209 9.34127137L18.9041035 9.34127137 18.9041035 10.8981499 9.56283209 10.8981499z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696876 9.34127137L29.4325197 9.34127137 29.4325197 10.8981499 20.8696876 10.8981499z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD059",
    d: "M8.03002381 36.0806606L18.1497345 36.0806606 18.1497345 43.0866142z",
    transform: "matrix(-1 0 0 1 26.18 0)"
  }))));
};
export default SpotChat;